import { supabase } from './supabaseClient'

// Profil (ligne de la table utilisateur) mis en cache pour la session courante
let cachedProfile = null
let cachedAuthId = null

/**
 * Retourne le profil de l'utilisateur connecté, ou null si personne n'est connecté.
 * La lecture passe par la RLS : seul le propriétaire de la ligne peut la lire.
 */
export async function getCurrentProfile({ refresh = false } = {}) {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session) {
    cachedProfile = null
    cachedAuthId = null
    return null
  }

  if (!refresh && cachedProfile && cachedAuthId === session.user.id) {
    return cachedProfile
  }

  const { data, error } = await supabase
    .from('utilisateur')
    .select('id, nom, prenom, mail, tel, role, login')
    .eq('auth_id', session.user.id)
    .maybeSingle()

  if (error) throw error

  cachedProfile = data ? { ...data, email: session.user.email } : null
  cachedAuthId = session.user.id
  return cachedProfile
}

export async function isAdmin() {
  const profile = await getCurrentProfile()
  return profile?.role === 'admin'
}

export async function signIn(email, password) {
  const { error } = await supabase.auth.signInWithPassword({ email, password })
  if (error) throw error

  const profile = await getCurrentProfile({ refresh: true })
  if (!profile) {
    await signOut()
    throw new Error('Aucun profil associé à ce compte')
  }

  await supabase
    .from('utilisateur')
    .update({ last_login: new Date().toISOString() })
    .eq('id', profile.id)

  return profile
}

export async function signOut() {
  cachedProfile = null
  cachedAuthId = null
  await supabase.auth.signOut()
}

export function onAuthChange(callback) {
  const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
    cachedProfile = null
    // Différé : appeler Supabase directement dans ce callback peut bloquer le client
    setTimeout(callback, 0)
  })
  return () => subscription.unsubscribe()
}
